import React, { useEffect, useState, useRef } from 'react';
import { useBlogContext } from '../../fetchdata/BlogContext';
import axiosInstance, { socketURL, weburl } from '../../axiosInstance';
import messageAlertSound from '../assets_user/audio/video_call.mp3';
import { Link,useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import getDecryptData from '../../helper/getDecryptData';

const LiveRequest = () => {
  const decryptdatajson = getDecryptData();
  const myid = decryptdatajson?._id;

  const { AllRequestReq, removeRequest } = useBlogContext();
  const [Loading, setLoading] = useState(true);
  const [Mybooking, setMybooking] = useState([]);
  const [FoundBook, setFoundBook] = useState(false);
  const [error, setError] = useState(null);

  // SINGLE audio instance for the lifetime of the component
  const audioRef = useRef(null);
  const isPlayingRef = useRef(false);

  // init audio once
  useEffect(() => {
    audioRef.current = new Audio(messageAlertSound);
    audioRef.current.preload = 'auto';

    const handleEnded = () => { isPlayingRef.current = false; };
    audioRef.current.addEventListener('ended', handleEnded);

    return () => {
      // cleanup
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.removeEventListener('ended', handleEnded);
      }
    };
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLiveBooks = async () => {
      if (Array.isArray(AllRequestReq) && AllRequestReq.length) {
        const updatedOrders = AllRequestReq.filter(order =>
          // keep your condition; adjust if userId isn't an array
          Array.isArray(order?.userId) ? order.userId.includes(myid) : order?.userId === myid
        );

        setMybooking(updatedOrders);
        setFoundBook(updatedOrders.length > 0);

        // Play only when we have items AND we're not already playing
        if (updatedOrders.length > 0 && !isPlayingRef.current && audioRef.current) {
          try {
            audioRef.current.currentTime = 0;
            await audioRef.current.play();
            isPlayingRef.current = true;
          } catch (e) {
            // autoplay may be blocked; avoid unhandled promise rejection
            console.warn('Audio play blocked:', e);
          }
        }

        // If items went to zero, stop/reset
        if (updatedOrders.length === 0 && isPlayingRef.current && audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          isPlayingRef.current = false;
        }
      } else {
        setMybooking([]);
        setFoundBook(false);
        // also stop if nothing
        if (isPlayingRef.current && audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          isPlayingRef.current = false;
        }
      }
    };

    fetchLiveBooks();
  }, [AllRequestReq, myid]);

  const CloseFoundBook = () => {
    setFoundBook(false);
    removeRequest();
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      isPlayingRef.current = false;
    }
  };
const AcceptFoundBook = (link) => {
  if (!link) {
    console.warn('No link provided for navigation');
    return;
  }
  
  setFoundBook(false);
  removeRequest();

  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    isPlayingRef.current = false;
  }

  console.log('Navigating to: ', `/video-call?videoId=${link}`);
  window.location.href = `/video-call?videoId=${link}`;
};

 
    return (
    <> 

 {(FoundBook && Mybooking.length !== 0) && (

<>
<div className='toast-wrap bg-transparent p-0'>  
     <div
  className="toast show my-toast-Book bg-transparent border-0 p-0 m-0 shadow-none"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  data-bs-delay={3000}
  data-bs-autohide="false"
>

  <div className="bg-transparent p-0 m-0">

<div
  className="p-0"
  style={{ maxWidth: 560 }}
>
   {Mybooking.map((booking, index) => (
  <div className="card-body p-4 mt-2 bg-light rounded border shadow" key={index} >
    {/* Top row: text + avatar */}
    <div className="d-flex align-items-start gap-3">
      <div className="flex-grow-1">
        <div className="text-muted small mb-1">Incoming Call</div>
        <div className="fw-bold fs-4">{booking.name}</div>
      </div>
      <img
        src={socketURL+booking.img}
        // src="https://i.pravatar.cc/100?img=12"
        alt="Caller"
        className="rounded-3 object-fit-cover"
        width={56}
        height={56}
      />
    </div>
    {/* Buttons */}
    <div className="row mt-4 g-3">
      <div className="col-12 col-sm-6">
        <button
          type="button"
          className="btn btn-danger btn-sm w-100 rounded-pill"
          onClick={CloseFoundBook}
        >
          Decline
        </button>
      </div>
      <div className="col-12 col-sm-6">
        <Link
          type="button"
          className="btn btn-success btn-sm w-100 rounded-pill"
        onClick={()=>{AcceptFoundBook(booking.link)}}
        >
          Accept
        </Link>
      </div>
    </div>
  </div>
    ))}
</div>
 
 
  </div>

    <div className="toast-header align-items-center d-none"> 
 
    <strong className="me-auto ms-2">New Request</strong>
    
       <button
      className="btn btn-danger position-relative px-1 btn-sm shadow-none px-3 py-1"
      type="button"
      onClick={CloseFoundBook} // Change onclick to onClick
      >
 Cancel 
    </button>
  </div>

</div> 
</div>
</>

    )}

</>


  )
}

export default LiveRequest
